import { FC } from "react";
import { CustomDayCellProps } from "..";
import Text from "../../../../../components/Text";

import styles from "./styles.module.scss";

const NoTradingDay: FC<CustomDayCellProps> = (props) => {
    const {
        sessions,
        hidePerformance: _omitHidePerformance,
        onEmptyWeekdayClick: _omit,
        isEmptyCalendarDayAddAllowed: _omitPred,
        onClick,
        ...rest
    } = props;

    return (
        <div {...rest} onClick={onClick}>
            <div className={styles.customDayCellContent}>
                <div className={styles.topCase}>
                    <Text className={styles.dayNumber} variant="body">
                        {rest.day.date.getDate()}
                    </Text>
                    <Text
                        variant="body-bold"
                        className={styles.total}
                    >
                        {"-"}
                    </Text>
                </div>
                <Text variant="caption" className={styles.sessionCount}>
                    {`${sessions.length} session(s)`}
                </Text>
                <Text variant="caption" className={styles.tradeCount}>
                    {`0 trade(s)`}
                </Text>
            </div>
        </div>
    );
};

export default NoTradingDay;
